import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[clickOutside]'
})
export class ClickOutsideDirective {
    @Output() clickOutside = new EventEmitter<MouseEvent>();

    constructor(private el: ElementRef) { }

    @HostListener('document:click', ['$event'])
    onClick(event: MouseEvent): void {
        // Check if the click happened outside the current element
        if (!this.el.nativeElement.contains(event.target)) {
            this.clickOutside.emit(event);
        }
    }
}